import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-hospitalsicon',
  templateUrl: './hospitalsicon.component.html',
  styleUrls: ['./hospitalsicon.component.css']
})
export class HospitalsiconComponent implements OnInit {
  partners = [
    { icon: '../../assets/img/pooja1.png' },
    { icon: '../../assets/img/pandit.png' },
    { icon: '../../assets/img/modernhospital.jpeg' },
    // {icon:'../../assets/img/modernhospital.jpeg'},
    {icon:"../../assets/img/kundan.png"},
    {icon:'../../assets/img/Alshifa health.png'},
    {icon:'../../assets/img/Dhampur.png'}
    // Add more partners as needed
  ];
  @ViewChild('partnerList', { static: true }) partnerList: ElementRef;
  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
    this.scrollNextPartner();
    setInterval(() => this.scrollNextPartner(), 20000);
  }
  private scrollNextPartner() {
    const partnerListWidth = this.partnerList.nativeElement.scrollWidth;
    const scrollPosition = this.partnerList.nativeElement.scrollLeft;
    const itemWidth = this.partnerList.nativeElement.offsetWidth;
    const nextScrollPosition = (scrollPosition + itemWidth) % partnerListWidth;

    this.renderer.setProperty(this.partnerList.nativeElement, 'scrollLeft', nextScrollPosition);
  }

}
